import React from "react";

const Card = ({ plan, selectmonth }) => {
  const {
    name,
    price,
    priceoffer,
    monthly_messages,
    links_to_crawl,
    max_chatbots,
  } = plan;

  const offer = typeof priceoffer === "object" ? priceoffer[selectmonth] : null;

  const launchPrice = offer?.launchOffer || price;
  const regularPrice = offer?.regular || price;
  const isBest = offer?.bestOffer;

  return (
    <div className="border border-gray-700 bg-stone-900 rounded-xl p-6 shadow-inner shadow-black text-white w-full">
      <h2 className="text-xl font-bold mb-3">{name} Plan</h2>

      <div className="mb-4">
        <p className="text-3xl font-semibold text-green-400">
          ${launchPrice}
          <span className="text-base text-gray-400 ml-2">
            / {selectmonth} month{selectmonth > 1 ? "s" : ""}
          </span>
        </p>
        {launchPrice !== regularPrice && (
          <p className="text-sm text-gray-400 line-through">${regularPrice}</p>
        )}
        {isBest && (
          <p className="text-sm text-yellow-400 font-medium mt-1">
            ⭐ Best Value Offer
          </p>
        )}
      </div>

      <ul className="text-sm space-y-2 mb-5">
        <li>💬 Messages/month: {monthly_messages}</li>
        <li>🔗 Links to crawl: {links_to_crawl}</li>
        <li>🤖 Max Chatbots: {max_chatbots}</li>
      </ul>
    </div>
  );
};

export default Card;
